import { render, staticRenderFns } from "./new-button.component.vue?vue&type=template&id=08581cfd&scoped=true"
import script from "./new-button.component.vue?vue&type=script&lang=js"
export * from "./new-button.component.vue?vue&type=script&lang=js"
import style0 from "./new-button.component.vue?vue&type=style&index=0&id=08581cfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08581cfd",
  null
  
)

export default component.exports